import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ClearUserSelectedDataRequest } from '../models/requests/clear-user-selected-data-request';
import { DeleteSapDataResponse } from '../models/requests/delete-sap-data-response';

@Injectable({
  providedIn: 'root',
})
export class SapDataService {
  constructor(private apiService: ApiService) {}

  public deleteByFilter(
    request: ClearUserSelectedDataRequest,
  ): Observable<DeleteSapDataResponse> {
    return this.apiService.delete<DeleteSapDataResponse>(`/SapData`, request);
  }
}
